import React from 'react';
import cyberSecurityResearchBg from '../../assets/images/cybersecurity-research.png';
import testingAndCredentialBg from '../../assets/images/testing-and-credential.png';
import threatAnalysisBg from '../../assets/images/threat-analysis.png';
import { ReactComponent as CyberResearchIcon } from '../../assets/svgs/cyberResearchIcon.svg';
import { ReactComponent as TestAndCredIcon } from '../../assets/svgs/testAndCredIcon.svg';
import { ReactComponent as ThreatAnalysisIcon } from '../../assets/svgs/threatAnalysisIcon.svg';
import MiniCard from '../MiniCard';
import SimpleButton from '../SimpleButton';
import FadeUp from '../animations/FadeUp';
import { ReactComponent as RightArrow } from '../../assets/svgs/rightArrow.svg';
interface CybersecurityWelcomeProps {
    id: string;
}

const CybersecurityWelcome: React.FC<CybersecurityWelcomeProps> = ({ id }) => {

    return (
        <div id={id} className="bg-white px-4 md:px-0 py-14 md:py-28 mx-auto ">
            <FadeUp>
                <div className='container mx-auto flex flex-col gap-10 md:gap-16 '>
                    <h1 className="mx-auto font-semibold text-center max-w-3xl text-4xl md:text-5xl font-jarkarta">Welcome to the Future of Cybersecurity: <span className='font-normal'>The Heartland Cyber Range</span></h1>
                    <p className="text-base md:text-xl text-custom-gray-dark md:text-center max-w-5xl mx-auto font-inter ">
                        Embarking on a cybersecurity journey has never been more immersive and practical. The Heartland Cyber Range is a cutting-edge, virtual platform designed to mimic real-world networks, systems, and applications, setting the gold standard for cybersecurity education and defense training. Here, theoretical knowledge seamlessly intertwines with hands-on practice, preparing you for the next generation of cyber challenges. Dive into this state-of-the-art realm and experience the forefront of cyber defense and education.
                    </p>
                    <div className="flex flex-wrap gap-8 md:gap-14 justify-center">
                        <div className="flex justify-center w-full md:w-auto">
                            <MiniCard title="Skill Development" icon={<TestAndCredIcon />} backgroundImage={testingAndCredentialBg} />
                        </div>
                        <div className="flex justify-center w-full md:w-auto">
                            <MiniCard title="Threat Simulation" icon={<ThreatAnalysisIcon />} backgroundImage={threatAnalysisBg} />
                        </div>
                        <div className="flex justify-center w-full md:w-auto">
                            <MiniCard title="Real-World Engaging Content" icon={<CyberResearchIcon />} backgroundImage={cyberSecurityResearchBg} />
                        </div>
                    </div>
                    <div className='flex justify-center'>
                        <SimpleButton
                            size="large"
                            label="Sign up now"
                            textColor='text-white'
                            bgColor='bg-custom-black'
                            Icon={RightArrow}
                            onClick={() => {
                                const element = document.getElementById("Sign Up");
                                element?.scrollIntoView({ behavior: 'smooth' });
                            }} />
                    </div>
                </div>
            </FadeUp >
        </div>
    );
};

export default CybersecurityWelcome;
